import React from 'react';
import { Form } from 'react-bootstrap';

// SCSS
import styles from './TextArea.module.scss';

interface ITextArea {
  placeholder?: string;
  name?: string;
  value?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea = (props: ITextArea) => {
  return (
    <Form.Control
      className={`${styles.mdrTextArea} ${props.className}`}
      placeholder={props.placeholder}
      as="textarea"
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled || false}
    />
  );
};

export default React.memo(TextArea);
